import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';
import previewTransactions from './PreviewTransactionsReducer';

export default combineReducers(
  Immutable.Map({
    previewTransactions
  })
);
